import { ELKLayoutConfig } from './types'

/**
 * Default ELK layout configuration for journey workflows
 * 
 * This configuration provides:
 * - Layered algorithm optimized for directed acyclic graphs (DAGs)
 * - Top-to-bottom layout direction
 * - Orthogonal (Manhattan-style) edge routing with 90-degree angles
 * - Consistent spacing between nodes and layers
 * - Adequate padding around the workflow content
 */
export const DEFAULT_ELK_CONFIG: ELKLayoutConfig = {
    algorithm: 'layered',            // Layered algorithm for DAGs
    direction: 'DOWN',               // Top-to-bottom layout
    edgeRouting: 'ORTHOGONAL',       // Manhattan-style routing with 90-degree angles
    nodeSeparation: 60,              // Horizontal space between nodes (px)
    rankSeparation: 60,              // Vertical space between levels (px)
    padding: 40,                     // Padding around the graph (px)
}

/**
 * Layout constants for journey builder
 * 
 * These constants control various aspects of the layout system:
 * - Node dimensions and constraints
 * - Add button positioning
 * - Viewport sizing and constraints
 * 
 * Note: MIN_NODE_WIDTH should match the CSS min-width of .custom-node (250px)
 * to prevent layout flickering when nodes are measured by React Flow
 */
export const LAYOUT_CONSTANTS = {
    MIN_NODE_HEIGHT: 60,             // Minimum node height (px)
    MIN_NODE_WIDTH: 250,             // Minimum node width (px) - matches CSS min-width
    ADD_BUTTON_OFFSET: 20,           // Distance from closest node to add button (px)
    MIN_VIEWPORT_WIDTH: 800,         // Minimum viewport width (px)
    MIN_VIEWPORT_HEIGHT: 600,        // Minimum viewport height (px)
} as const
